import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import pt from './locales/pt.json'
import en from './locales/en.json'
import es from './locales/es.json'
import fr from './locales/fr.json'
import it from './locales/it.json'
const resources = { pt:{translation:pt}, en:{translation:en}, es:{translation:es}, fr:{translation:fr}, it:{translation:it} }
i18n.use(LanguageDetector).use(initReactI18next).init({
  resources, fallbackLng:'pt', interpolation:{ escapeValue:false },
  detection:{ order:['localStorage','navigator','htmlTag'], caches:['localStorage'], lookupLocalStorage:'lang' }
})
export default i18n
